export default __webpack_public_path__ + "static/media/unchecked.108c67ab.svg";